import type { PumpStatus } from "@tandemdiabetes/sugarmate-api-react-client"
import {
  ModalBody,
  ModalCloseX,
  ModalContent,
  ModalHeading,
  ExclamationFillIcon,
} from "@tandemdiabetes/sugarmate-react-components"

import styles from "./PumpStatusMalfunctionModalContent.module.scss"

import { UserData } from "src/components"
import { usePolyglot } from "src/contexts"

const polyglotPrefix = "pages.home.pump_status_modal.malfunction."

interface Props {
  pumpStatus: PumpStatus;
}

/*
 * this component renders the modal content for when there is a pump malfunction
 */
export function PumpStatusMalfunctionModalContent(props: Props) {
  const { pumpStatus } = props

  const polyglot = usePolyglot()

  return (
    <ModalContent>
      <ModalHeading>
        <div className={styles.headingTextContainer}>
          <UserData pumpStatus={pumpStatus} />
          <div className={styles.subheadingContainer}>
            <ExclamationFillIcon className={styles.icon} />
            <div>
              {polyglot.t(`${polyglotPrefix}header`)}
            </div>
          </div>
        </div>
        <ModalCloseX id="pump-status-modal-close-btn" />
      </ModalHeading>
      <ModalBody className={styles.body}>
        <div className={styles.paragraph1}>
          {polyglot.t(`${polyglotPrefix}paragraph1`)}
        </div>
        <div className={styles.paragraph2}>
          {polyglot.t(`${polyglotPrefix}paragraph2`)}
        </div>
        <div className={styles.paragraph3}>
          {polyglot.t(`${polyglotPrefix}paragraph3`)}
        </div>
      </ModalBody>
    </ModalContent>
  )
}
